import { gql } from '@apollo/client';

import { threadAnswerFragment } from '../fragments';

export default gql`
  mutation UpvoteThreadAnswer(
    $courseId: String!
    $threadId: String!
    $answerId: String!
  ) {
    upvoteThreadAnswer(
      courseId: $courseId
      threadId: $threadId
      answerId: $answerId
      input: {}
    )
      @rest(
        type: "ThreadAnswer"
        path: "/courses/{args.courseId}/threads/{args.threadId}/answers/{args.answerId}/upvote"
        method: "PUT"
      ) {
      ...ThreadAnswer
    }
  }
  ${threadAnswerFragment}
`;
